import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

/**
 * Icon wrapper
 * @param {object} props
 * @param {React.Component} props.children
 * @param {string} [props.title]
 * @param {'small'|'medium'|'large'|'inherit'} [props.size='small']
 */
const IconWrapper = (props) => {
  const { children, size = 'small', title = '' } = props

  return (
    <SvgIcon
      fontSize={size}
      titleAccess={title}
    >
      {children}
    </SvgIcon>
  )
}

export default IconWrapper
